import { Link } from 'react-router-dom';

export default function ServicesOverview() {
  const services = [
    {
      icon: 'ri-home-smile-line',
      title: 'Property Setup',
      description: 'Complete property preparation including staging, photography, and listing optimization',
      link: '/services'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Code Compliance',
      description: 'Ensure your property meets all local regulations and safety requirements',
      link: '/services'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Revenue Optimization',
      description: 'Dynamic pricing strategies to maximize your rental income',
      link: '/services'
    },
    {
      icon: 'ri-customer-service-line',
      title: '24/7 Management',
      description: 'Full-service property management with guest communication and maintenance',
      link: '/services'
    }
  ];

  return (
    <section className="py-12 sm:py-16 md:py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-10 sm:mb-12 md:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-3 sm:mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            Our Services
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-2xl mx-auto leading-relaxed px-4">
            Everything you need to launch and manage a successful Airbnb property
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {services.map((service, index) => (
            <Link
              key={index}
              to={service.link}
              className="group bg-white p-6 sm:p-8 rounded-2xl border-2 border-gray-100 hover:border-[#FF6B6B] transition-all duration-300 hover:shadow-xl cursor-pointer"
            >
              <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-[#FF6B6B]/10 rounded-xl mb-4 sm:mb-6 group-hover:bg-[#FF6B6B] transition-all">
                <i className={`${service.icon} text-3xl sm:text-4xl text-[#FF6B6B] group-hover:text-white transition-all w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center`}></i>
              </div>
              <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2 sm:mb-3">
                {service.title}
              </h3>
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed mb-4 sm:mb-6">
                {service.description}
              </p>
              <div className="flex items-center text-[#FF6B6B] font-semibold text-sm sm:text-base group-hover:gap-2 transition-all">
                Learn More
                <i className="ri-arrow-right-line ml-2 w-5 h-5 flex items-center justify-center"></i>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10 sm:mt-12 md:mt-16">
          <Link
            to="/services"
            className="inline-block bg-[#FF6B6B] text-white px-8 sm:px-10 py-4 sm:py-5 rounded-lg font-semibold text-base sm:text-lg hover:bg-[#ff5252] transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
          >
            View All Services
          </Link>
        </div>
      </div>
    </section>
  );
}
